import styled from '@emotion/styled';

export const TextButtonContainer = styled.p`
  font-family: 'Inter', sans-serif;
`;
